import { render, staticRenderFns } from "./v-phone.vue?vue&type=template&id=80612b14&scoped=true&"
import script from "./v-phone.vue?vue&type=script&lang=js&"
export * from "./v-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80612b14",
  null
  
)

export default component.exports